module.exports = __webpack_public_path__ + "static/media/ICE.20bc90e4.png";